import { render, staticRenderFns } from "./FeedBackStatusActive.vue?vue&type=template&id=b162b3e0&"
import script from "./FeedBackStatusActive.vue?vue&type=script&lang=js&"
export * from "./FeedBackStatusActive.vue?vue&type=script&lang=js&"
import style0 from "./FeedBackStatusActive.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports